import React from "react";
import { AlertTriangle } from "lucide-react";
import { useRacketLabAdminT } from "../../i18n/racketLabAdminI18n";

/**
 * PilotBanner — RL admin shell.
 *
 * HARD-required by `GO RL-FRONTEND-SHELL-V0` decision matrix. Visible
 * on every Racket Lab admin page so any admin operating the shell is
 * reminded that the surface is the **internal controlled pilot** and
 * NOT public production.
 *
 * QUICK 1.B.bis i18n migration: visible copy is now resolved via
 * `racketLab.banners.pilot_mode_*` so the banner reads in the active
 * UI language across the whole admin shell. `data-testid` unchanged.
 */
export const PilotBanner = () => {
  const t = useRacketLabAdminT();
  return (
    <div
      data-testid="rl-admin-pilot-banner"
      className="flex items-center gap-2 rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-xs text-amber-900"
    >
      <AlertTriangle className="w-4 h-4 shrink-0" aria-hidden />
      <span className="font-medium">
        {t("banners.pilot_mode_primary")}
      </span>
      <span className="hidden md:inline text-amber-700">
        · {t("banners.pilot_mode_secondary")}
      </span>
    </div>
  );
};

export default PilotBanner;
